import { Event } from '@/app/event-stream';
import { OperatorFunction, Observable } from 'rxjs';
import { filterByTypeOperator, Mapper } from './filter-by-type-operator';
import { SectionStatusEvent, SectionStatusChangedEventName } from '@/app/statistics/events/section-status-events';
import { filterStatusEventsOperator } from './filter-status-events-operator';

export function filterEventsOperator(params: { statusChangeDebounceMs: number }): OperatorFunction<Event, Event> {

  function sectionStatusChanged(input: Observable<Event>) {
    return (input as Observable<SectionStatusEvent>).pipe(
      filterStatusEventsOperator({ debounceMs: params.statusChangeDebounceMs } ));
  }

  const mappers: Mapper[] = [
    { key: SectionStatusChangedEventName, mapper: sectionStatusChanged }
  ];

  return (input$) => input$.pipe(filterByTypeOperator(mappers));
}
